goog.provide("shadow.js.shim.module$react_markdown");
goog.provide("module$shadow_js_shim_module$react_markdown");
shadow.js.shim.module$react_markdown = shadow.js.nativeProvides["react-markdown"] = shadow$bridge("react-markdown");
module$shadow_js_shim_module$react_markdown.default = shadow.js.shim.module$react_markdown;
